import videojs from 'video.js';

import OpenCamera from '@Components/OpenCamera/component.js';

// Get the Component base class from Video.js
const Button = videojs.getComponent('Button');

// The videojs.extend function is used to assist with inheritance. In
// an ES6 environment, `class TitleBar extends Component` would work
// identically.
var DownloadVideo = videojs.extend(Button, {

  // The constructor of a component receives two arguments: the
  // player it will be associated with and an object of options.
  constructor: function(player, options) {

    // It is important to invoke the superclass before anything else, 
    // to get all the features of components out of the box!
    Button.call(this, player, options);

    this.addClass('vjs-button-download-video');
    this.addClass('vjs-icon-download');

    this.player().ready(() => {
      this.show();
    });
  },

  handleClick(event) {
    this.player().trigger('downloadRecording');
  },

  createEl(tag, props = {}, attributes = {}) {
    const el = Button.prototype.createEl.call(this, tag, props, attributes);
    el['innerHTML'] = '<span aria-hidden="true" class="vjs-icon-placeholder">Descargar</span>';

    this.createControlTextEl(el);

    return el;
  },

});

DownloadVideo.prototype.controlText_ = 'Descargar grabación';

// Register the component with Video.js, so it can be used in players.
videojs.registerComponent('DownloadVideo', DownloadVideo);

export default DownloadVideo;
